var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0026 0C8.95562 0 0 8.95562 0 20.0026C0 31.0444 8.95562 40 20.0026 40C31.0444 40 40 31.0444 40 20.0026C40 8.95562 31.0444 0 20.0026 0ZM27.6044 15.7619C27.6096 15.941 27.6149 16.1201 27.6149 16.2992C27.6149 21.7832 23.5427 28.1101 16.099 28.1101C13.8127 28.1101 11.6844 27.42 9.89332 26.2452C10.2094 26.2821 10.5308 26.3032 10.8574 26.3032C12.7539 26.3032 14.5028 25.6394 15.8883 24.5279C14.113 24.491 12.6222 23.2951 12.1059 21.6463C12.3535 21.6937 12.6063 21.72 12.8645 21.72C13.2385 21.72 13.6389 21.6673 13.976 21.5725C12.1217 21.1932 10.7678 19.5127 10.7678 17.5003V17.4529C11.2946 17.7585 11.9004 17.9481 12.5642 17.9692C11.4737 17.2264 10.7415 15.9515 10.7415 14.5134C10.7415 13.7548 10.9311 13.0383 11.2788 12.4272C13.2754 14.9401 16.2518 16.589 19.6181 16.7628C19.5443 16.4573 19.5101 16.1412 19.5101 15.8198C19.5101 13.5282 21.3207 11.6686 23.5549 11.6686C24.7191 11.6686 25.7716 12.1691 26.5092 12.9751C27.4311 12.7907 28.295 12.4483 29.0799 11.9689C28.7797 12.9382 28.1364 13.7548 27.2988 14.2658C28.1206 14.1657 28.9003 13.9444 29.622 13.6125C29.0847 14.4449 28.3946 15.1771 27.6044 15.7619Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default ForwardRef;